import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const LoginLayout = () => {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/points" />;
  }

  return (
    <div>
      <Outlet />
    </div>
  );
};
